import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import brochure_bg from '../../assets/images/brochure_bg.webp';
// import MuiImageSlider from 'mui-image-slider';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import industries_1 from '../../assets/images/industries_1.jpg';
import industries_2 from '../../assets/images/industries_2.jpg';
import industries_3 from '../../assets/images/industries_3.jpg';
import industries_4 from '../../assets/images/industries_4.jpg';
import industries_5 from '../../assets/images/industries_5.jpg';
import industries_6 from '../../assets/images/industries_6.jpg';
import industries_7 from '../../assets/images/industries_7.jpg';
import industries_8 from '../../assets/images/industries_8.jpg';
import industries_9 from '../../assets/images/industries_9.jpg';
import industries_10 from '../../assets/images/industries_10.jpg';
import industries_11 from '../../assets/images/industries_11.gif';
import industries_12 from '../../assets/images/industries_12.jpg';
import industries_17 from '../../assets/images/industries_17.jpg';
import industries_16 from '../../assets/images/industries_16.jpg';
import industries_22 from '../../assets/images/industries_22.jpg';
import industries_20 from '../../assets/images/industries_20.jpg';
import industries_24 from '../../assets/images/industries_24.jpg';
import industries_27 from '../../assets/images/industries_27.jpg';
import industries_28 from '../../assets/images/industries_28.jpg';
import industries_30 from '../../assets/images/industries_30.jpg';
import industries_19 from '../../assets/images/industries_19.jpg';
import industries_21 from '../../assets/images/industries_21.jpg';
import { useNavigate } from 'react-router-dom';

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';


function NextArrow(props) {
  const { onClick } = props;

  return (
    <div
      onClick={onClick}
      style={{
        position: "absolute",
        right: "25px",
        top: "46.5%",
        transform: "translateY(-50%)",
        zIndex: 2,
        background: "#f7f1ee",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
        transition: "background 0.3s ease"
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.background = "#e5ddd9")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.background = "#f7f1ee")
      }
    >
      <ArrowForwardIosIcon style={{ fontSize: "18px", color: "#9a4a1f" }} />
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;

  return (
    <div
      onClick={onClick}
      style={{
        position: "absolute",
        left: "25px",
        top: "46.5%",
        transform: "translateY(-50%)",
        zIndex: 2,
        background: "#f7f1ee",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
        transition: "background 0.3s ease",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.background = "#e5ddd9")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.background = "#f7f1ee")
      }
    >
      <ArrowBackIosNewIcon style={{ fontSize: "18px", color: "#9a4a1f" }} />
    </div>
  );
}

const industries = [
    {
      image: industries_1,
      titleKey: 'industries.cement.title',
      descriptionKey: 'industries.cement.description'
    },
    {
      image: industries_16,
      titleKey: 'industries.pharmaceutical.title',
      descriptionKey: 'industries.pharmaceutical.description',
      title: 'Pharmaceutical Industry'
    },
    {
      image: industries_7,
      titleKey: 'industries.constructionMaterials.title',
      descriptionKey: 'industries.constructionMaterials.description'
    },
    {
      image: industries_21,
      titleKey: 'industries.rubber.title',
      descriptionKey: 'industries.rubber.description',
      title: 'Rubber Industry'
    },
    {
      image: industries_12,
      titleKey: 'industries.steel.title',
      descriptionKey: 'industries.steel.description'
    },

    {
      image: industries_22,
      titleKey: 'industries.constructionMaterials.title',
      descriptionKey: 'industries.constructionMaterials.description'
    },
    
    {
      image: industries_17,
      titleKey: 'industries.animalFeed.title',
      descriptionKey: 'industries.animalFeed.description'
    },
    
    {
      image: industries_27,
      titleKey: 'industries.paper.title',
      descriptionKey: 'industries.paper.description'
    },
    {
      image: industries_3,
      titleKey: 'industries.plastics.title',
      descriptionKey: 'industries.plastics.description'
    },
    {
      image: industries_20,
      titleKey: 'industries.paintIndustry.title',
      descriptionKey: 'industries.paintIndustry.description'
    },
    {
      image: industries_19,
      titleKey: 'industries.glassIndustry.title',
      descriptionKey: 'industries.glassIndustry.description'
    },
    {
      image: industries_24,
      titleKey: 'industries.agriculturalFertilizerIndustry.title',
      descriptionKey: 'industries.agriculturalFertilizerIndustry.description'
    },
    {
      image: industries_28,
      titleKey: 'industries.foodIndustry.title',
      descriptionKey: 'industries.foodIndustry.description'
    },
    {
      image: industries_30,
      titleKey: 'industries.petroleumAndGasIndustry.title',
      descriptionKey: 'industries.petroleumAndGasIndustry.description'
    },
  ];

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 2000,
  cssEase: "linear",
//   className: "center",
  // centerMode: true,
  // centerPadding: "60px",
//   adaptiveHeight: true,
  // dots: true,
  // infinite: true,
  // speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  rows: 2,
//   slidesPerRow: 2,
//   slidesToShow: 3,
//   swipeToSlide: true,
//   centerPadding: "60px",
//   className: "center",
  rtl: true,

//   afterChange: function(index) {
//     console.log(
//       `Slider Changed to: ${index + 1}, background: #222; color: #bada55`
//     );
//   }


// className: "center",
//     centerMode: true,
//     infinite: true,
//     centerPadding: "60px",
//     slidesToShow: 3,
//     speed: 500,
//     rows: 2,
//     slidesPerRow: 4,
//     slidesToScroll: 4,
//     dots: false,
//     slidesToScroll: 1,
//     autoplay: true,
//     // speed: 10000,

};

const BrochureContent = styled('div')({
  // backgroundColor:'green'
  maxWidth: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  position: 'relative',
  zIndex: 2,
});

const ApplicationsSlider = () => {
  const { t, i18n } = useTranslation();
  const navigator = useNavigate();
  return (
    <div>
    <h2 style={{color: 'rgb(154,74,32)', marginBottom: '10px'}}>{t('navigation.applications')}</h2>
    <div className="slider-container" >
      <Slider {...settings}>
        {industries.map((item, index) => (
        <div key={index} style={{ width: '400px', cursor: 'pointer', outline: 'none', textAlign: 'center' }} onDoubleClick={() => {
            console.log(item)
            navigator('/applications')
        }}>
          <div className='hoverSlider'>
              <img
                src={item.image}
                width={'95%'}
                height={250}
                style={{ backgroundRepeat: 'no-repeat', objectFit: 'cover', borderRadius: '5px',cursor: 'pointer' }}

              />
              <p style={{fontSize: '13px',fontWeight: 500 , overflow:'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#7f6001',marginTop:'5px', marginBottom: '5px' }}>{t(item.titleKey)}</p>

          </div>
        </div>
        ))}
        
      </Slider>
    </div>
    </div>
  );
};

export default ApplicationsSlider;

